var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Injectable } from 'angular-ts-decorators';
let SettingsService = class SettingsService {
    $q;
    $http;
    settingsCache = {};
    secureSettingsCache = {};
    listeners = [];
    // Minification-safe CI injections, everything @Inject()ed somewhere must be mentioned here:
    static $inject = ['$http', '$q'];
    constructor($http, $q) {
        this.$http = $http;
        this.$q = $q;
    }
    findDeep(settings, path) {
        if (!path) {
            return settings;
        }
        return path.split('.').reduce((prev, curr) => {
            return prev ? prev[curr] : undefined;
        }, settings);
    }
    getRevisions(organizationId, limit, page) {
        let url = '/admin/subscription-revisable-settings/revisions';
        url += '?organization_id=' + (organizationId ? organizationId : '');
        url += limit && !isNaN(page ?? 0) ? `&limit=${limit}&page=${page}` : '';
        return this.$http.get(url).catch((err) => {
            console.error('Failed to fetch revisions', err);
            throw err;
        });
    }
    getActiveRevisions(organizationId) {
        let url = '/admin/subscription-revisable-settings/revisions/active';
        url += '?organization_id=' + (organizationId ? organizationId : '');
        return this.$http.get(url).catch((err) => {
            console.error('Failed to fetch active revisions', err);
            throw err;
        });
    }
    setRevisionAsActive(revision) {
        const url = '/admin/subscription-revisable-settings/revisions/' + revision.id + '/activate';
        return this.$http.put(url, revision).catch((err) => {
            console.error('Failed to set revision as active', err);
            throw err;
        });
    }
    createRevision(revision) {
        const url = '/admin/subscription-revisable-settings/revisions';
        return this.$http.post(url, revision).catch((err) => {
            console.error('Failed to create revision', err);
            throw err;
        });
    }
    deleteRevision(revision_id) {
        const url = '/admin/subscription-revisable-settings/revisions/' + revision_id;
        return this.$http.delete(url).catch((err) => {
            console.error('Failed to delete revision', err);
            throw err;
        });
    }
    updateRevision(revision) {
        const url = '/admin/subscription-revisable-settings/revisions/' + revision.id;
        return this.$http.put(url, revision).catch((err) => {
            console.error(err);
            throw err;
        });
    }
    approveRevision(revision) {
        const url = '/admin/subscription-revisable-settings/revisions/' + revision.id + '/approve';
        return this.$http.put(url, revision).catch((err) => {
            console.error(err);
            throw err;
        });
    }
    addChangeListener(id, path, callback) {
        this.listeners.push({ id, path, callback });
    }
    removeChangeListener(id) {
        this.listeners = this.listeners.filter((listener) => listener.id !== id);
    }
};
SettingsService = __decorate([
    Injectable('SettingsService'),
    __metadata("design:paramtypes", [typeof (_a = typeof ng !== "undefined" && ng.IHttpService) === "function" ? _a : Object, typeof (_b = typeof ng !== "undefined" && ng.IQService) === "function" ? _b : Object])
], SettingsService);
export { SettingsService };
